/**
 * Global Component Dependencies
 */
import Btn from './general/Btn'
import Row from './general/Row'
import Tabs from './general/Tabs'
import Card from './general/Card'
import Column from './general/Column'
import Notice from './general/Notice'
import TabPane from './general/TabPane'
import BtnGroup from './general/BtnGroup'
import Branding from './general/Branding'
import ProgressBar from './general/ProgressBar'
import SuccessCheck from './general/SuccessCheck'
import PercentageBar from './general/PercentageBar'
import LoadingSpinner from './general/LoadingSpinner'
import SectionHeading from './general/SectionHeading'

/**
 * Global Custom Input Dependencies
 */
import Tags from './general/forms/TagsField'
import CheckBox from './general/forms/CheckBox'
import YearField from './general/forms/YearField'
import DateField from './general/forms/DateField'
import TextField from './general/forms/TextField'
import MonthField from './general/forms/MonthField'
import NumberField from './general/forms/NumberField'
import SelectField from './general/forms/SelectField'
import AddressField from './general/forms/AddressField'
import ZipcodeField from './general/forms/ZipcodeField'
import CurrencyField from './general/forms/CurrencyField'
import PercentageField from './general/forms/PercentageField'
import StateSelectField from './general/forms/StateSelectField'
import MultiSelectField from './general/forms/MultiSelectField'
import TextareaField from './general/forms/TextareaField'

/**
 * Global Custom Table Dependencies
 */
import TableHeader from './general/tables/TableHeader'

/**
 * Global Components
 *
 * @type {Object}
 */
const components = {
    'btn': Btn,
    'row': Row,
    'tabs': Tabs,
    'card': Card,
    'notice': Notice,
    'column': Column,
    'tags-field': Tags,
    'tab-pane': TabPane,
    'branding': Branding,
    'check-box': CheckBox,
    'btn-group': BtnGroup,
    'date-field': DateField,
    'text-field': TextField,
    'year-field': YearField,
    'month-field': MonthField,
    'progress-bar': ProgressBar,
    'number-field': NumberField,
    'select-field': SelectField,
    'table-header': TableHeader,
    'address-field': AddressField,
    'success-check': SuccessCheck,
    'zipcode-field': ZipcodeField,
    'percentage-bar': PercentageBar,
    'currency-field': CurrencyField,
    'section-heading': SectionHeading,
    'loading-spinner': LoadingSpinner,
    'percentage-field': PercentageField,
    'state-select-field': StateSelectField,
    'multi-select-field': MultiSelectField,
    'textarea-field': TextareaField
}

export default components



// WEBPACK FOOTER //
// ./src/components/index.js